module.exports = __webpack_public_path__ + "static/img/pd_top_2.9ca4f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_top_2.jpg
// module id = YaFa
// module chunks = 52